import React, { useEffect, useState } from 'react'
import '../assets/css/style.css';
import '../style/HomeScreen.css'




const HangingBannerUI = () => {
  const [links, setlinkJson] = useState()
  useEffect(() => {
    fetch(`${window.location.origin}/app/rbilandinglinks.json`)
      .then((res) => {
        return res.json()
      }).then((data) => {
        setlinkJson(data)

      }).catch(err => console.log(err));
  }, []);


  return (
    <div className="hanging-banner">
      <a
        // href="https://www.ccilindia.com/Research/Statistics/Pages/TenorwiseIndicativeYields.aspx"
        // href="https://www.ccilindia.com/web/ccil/tenorwise-indicative-yields"
        href={links?.tenorHanging}

        target="_blank"
        className="swing animated infinite"
      >
        Tenor-wise Indicative Yields <i className="ri-arrow-down-line"></i>
      </a>
    </div>)
}; export default HangingBannerUI;